import { DragDropModule } from '@angular/cdk/drag-drop';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlexLayoutModule } from 'ngx-flexible-layout';
//external modules
import { AbcCommonEditorsModule } from '@barthauer/abc/common-editors';
import { AuthenticationGuard } from '@barthauer/abc/core/authentication';
import { UsersModule } from '@barthauer/abc/management/users';
//external services
import { AbcConfigService } from '@barthauer/abc/core/configuration';
//external components
import { AbcExpressionsEditorService, ExpressionsEditorModule } from '@barthauer/abc/queries/opath/expressions-editor';
import {
  _AbcDrawerComponent,
  _AbcGridComponent,
  _AbcTextAreaComponent,
  _AbcTreeComponent,
  AbcContainerService,
  AbcCoreContainerService,
  AbcDropDownBoxButtonComponent,
  AbcHtmlEditorComponent,
  AbcListComponent,
  AbcPopupComponent,
  AbcSplitterV2Component,
  AbcUiComponentsModule,
  _AbcSelectBoxComponent,
  _AbcSplitterComponent,
  _AbcButtonComponent,
  AbcDropDownBoxComponent,
  _AbcSwitchComponent,
} from '@barthauer/abc/ui-components';
import { DxPopupModule, DxTooltipModule, DxTreeViewComponent } from 'devextreme-angular';
import { environment } from '../environments/environment';
import { AbcArenaComponent } from './abc-arena.component';
import { AbcArenaService } from './abc-arena.service';
//internal modules
//internal services / guards
import { AbcCoreModule } from '@barthauer/abc/core';
import { ObjectsSetsModule } from '@barthauer/abc/ui-frameworks/objects-sets';
import { ConfigService } from './configuration/config.service';
import { ArenaComponent } from './core/arena.component';
import { DynamicTabsDirective, DynamicTopDirective } from './core/data-form/core/dynamic.directive';
import { DataFormComponent } from './core/data-form/data-form.component';
import { HignaComponent } from './core/higna/higna.component';
import { HigonComponent } from './core/higon/higon.component';
import { MenuComponent } from './core/menu/menu.component';
import { NavigationComponent } from './core/navigation/navigation.component';
import { SettingsComponent } from './core/settings/settings.component';
import { ArenaSettingsService } from './services/arena-settings.service';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    AbcArenaComponent,
    ArenaComponent,
    DataFormComponent,
    HigonComponent,
    HignaComponent,
    NavigationComponent,
    SettingsComponent,
    MenuComponent,
    DynamicTabsDirective,
    DynamicTopDirective,
  ],
  bootstrap: [AbcArenaComponent],
  exports: [AbcArenaComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AbcCoreModule,
    AbcUiComponentsModule,
    FlexLayoutModule,
    AbcCommonEditorsModule,
    UsersModule,
    ExpressionsEditorModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatTooltipModule,
    MatBadgeModule,
    DragDropModule,
    MatButtonToggleModule,
    DxPopupModule,
    _AbcTreeComponent,
    _AbcDrawerComponent,
    AbcListComponent,
    AbcHtmlEditorComponent,
    _AbcTextAreaComponent,
    DxTooltipModule,
    _AbcGridComponent,
    AbcPopupComponent,
    _AbcSplitterComponent,
    ObjectsSetsModule,
    AbcSplitterV2Component,
    AbcDropDownBoxButtonComponent,
    _AbcSelectBoxComponent,
    _AbcButtonComponent,
    AbcDropDownBoxComponent,
    _AbcSwitchComponent,
    DxTreeViewComponent,
  ],
  providers: [
    AbcArenaService,
    AuthenticationGuard,
    AbcConfigService,
    ConfigService,
    AbcContainerService,
    AbcCoreContainerService,
    ArenaSettingsService,
    AbcExpressionsEditorService,
    provideAppInitializer(() => {
      const initializerFn = ConfigurationFactory(inject(ConfigService), inject(AbcConfigService));
      return initializerFn();
    }),
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AbcArenaModule {}
// Loading the config parameters each time we run/load the application
export function ConfigurationFactory(arenaConfig: ConfigService, globalConfig: AbcConfigService) {
  return () => {
    return new Promise((resolve, reject) => {
      globalConfig.loadConfig(environment.webArenaConfigUrl).then((result) => {
        resolve(arenaConfig.load(result).then(() => resolve(result)));
      });
    });
  };
}
